import { cn } from "@/shared/lib";

interface ToggleProps {
  checked: boolean;
  onChange: (value: boolean) => void;
  disabled?: boolean;
  "aria-label"?: string;
}

/**
 * トグルスイッチコンポーネント
 * セマンティックカラー（primary/muted）を使用したアクセシブルなスイッチ
 */
export const Toggle: React.FunctionComponent<ToggleProps> = ({
  checked,
  onChange,
  disabled,
  "aria-label": ariaLabel,
}: ToggleProps) => (
  <button
    type="button"
    onClick={(): void => onChange(!checked)}
    disabled={disabled}
    className={cn(
      "relative h-6 w-11 rounded-full transition-colors before:absolute before:top-1 before:h-4 before:w-4 before:rounded-full before:transition-transform before:content-['']",
      checked
        ? "bg-primary before:left-6 before:bg-background"
        : "bg-muted before:left-1 before:bg-foreground",
      disabled && "opacity-50 cursor-not-allowed",
    )}
    role="switch"
    aria-checked={checked}
    aria-label={ariaLabel}
  ></button>
);
